// 第三方
import * as React from "react";
import { observer } from "mobx-react";
// UI
import {
	PcCdBannerBox,
	PcCdBannerContainer,
	PcCdBannerContent,
	PcCdBannerExpired,
	PcCdBannerNum,
	PcCdBannerSymbol,
} from "./styles";
// 组件
import NextImage from "views/components/NextImage";
// utils
import { getLitbLangFn } from "utils/language";
import { endUnit, EnFormateDays, formatDate, formatMinutesAndSeconds } from "utils/time";
// typings
import { PCLitbCountdownStore } from "./store";
import { TModuleWithImgProps, TCountdownModule } from "../../../services/playground";
import { TActState, TBannerItem } from "../../../services/banner";
import { formatBannerGridSize, isUnValidState, isValidState } from "views/utils/banner";

export interface CountdownBannerMod {
	banner: TBannerItem;
	actState: TActState;
	timer: TCountdownModule;
}

export interface CountdownBannerProps extends TModuleWithImgProps {
	banner: TBannerItem;
	actState: TActState;
	timer: TCountdownModule;
	onRefresh: () => Promise<CountdownBannerMod>;
}
@observer
export default class CountdownBanner extends React.Component<CountdownBannerProps> {
	store: PCLitbCountdownStore;
	constructor(props: CountdownBannerProps | Readonly<CountdownBannerProps>) {
		super(props);
		this.store = new PCLitbCountdownStore(props.actState, props.timer, props.onRefresh);
	}

	componentWillUnmount() {
		clearInterval(this.store.intervalId);
	}

	get title() {
		const { state, timer, countDown } = this.store;
		const { language } = this.props;
		switch (state) {
			case TActState.ComingSoon:
				return `${getLitbLangFn("Starts On", language)} ${formatDate(
					parseInt(timer?.start, 10) * 1000,
					language,
				)}`;
			case TActState.OnGoing:
				return `Ends In ${EnFormateDays(countDown)} ${endUnit(language)}`;
			default:
				return `${getLitbLangFn("We‘re sorry，the offer has expired.", language)}`;
		}
	}
	render() {
		const {
			positionId,
			banner,
			minWidth = 0,
			width = "0",
			placeholderBg,
			style = {},
			moduleIndex,
		} = this.props;
		const { width: gridWidth, height } = formatBannerGridSize(
			banner,
			Math.max(+width, minWidth),
		);
		const { state, countDown } = this.store;
		if (isUnValidState(state)) {
			return (
				<PcCdBannerExpired id={positionId}>
					<p className="expiredTitle">{this.title}</p>
				</PcCdBannerExpired>
			);
		}
		if (!banner) {
			return null;
		}
		const validBannerStatus = isValidState(state);
		return (
			<section id={positionId}>
				<PcCdBannerContainer
					gridWidth={gridWidth}
					gridHeight={banner?.height && validBannerStatus ? height : 0}
					style={{
						...style,
					}}
				>
					{validBannerStatus && (
						<React.Fragment>
							<NextImage
								src={banner.img}
								online={true}
								placeholder={placeholderBg}
								fallbackSrc={placeholderBg}
								style={{
									width: width || "100%",
									height,
								}}
								moduleIndex={moduleIndex}
							/>
							<PcCdBannerContent>
								<PcCdBannerBox>
									<p className="pc_countdownTitle">{this.title}</p>
									<section>
										{formatMinutesAndSeconds(countDown, state).map(
											(item, index) => {
												return (
													<React.Fragment key={`${index}`}>
														{item.split("").map((i, idx) => (
															<PcCdBannerNum key={`${idx}_${i}`}>
																{i}
															</PcCdBannerNum>
														))}
														{!!(index < 2) && (
															<PcCdBannerSymbol>:</PcCdBannerSymbol>
														)}
													</React.Fragment>
												);
											},
										)}
									</section>
								</PcCdBannerBox>
							</PcCdBannerContent>
						</React.Fragment>
					)}
				</PcCdBannerContainer>
			</section>
		);
	}
}
